import { render, staticRenderFns } from "./DetectMicro.vue?vue&type=template&id=2f9953bc&scoped=true&"
import script from "./DetectMicro.vue?vue&type=script&lang=js&"
export * from "./DetectMicro.vue?vue&type=script&lang=js&"
import style0 from "./DetectMicro.vue?vue&type=style&index=0&id=2f9953bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9953bc",
  null
  
)

export default component.exports